import React, { useEffect, useState } from "react";
import Dashboard from "../components/AdminDashboard";
import { Tabs, Tab, Spinner, Alert, Modal, Button } from "react-bootstrap";
import CustomHelmet from "../components/CustomHelmet";
import Fade from "react-reveal/Fade";
import AdminListingContainer from "../components/AdminListingContainer";
import axios from "axios";
import Pagination from "../components/Pagination";

const urlUpdate =
  "https://www.hubsquares.com/php_files/approveListing.php/";
const urlDecline =
  "https://www.hubsquares.com/php_files/declineListing.php/";
const url = "https://www.hubsquares.com/php_files/fetchLisiting.php/";
const urlRemove =
  "https://www.hubsquares.com/php_files/removeListing.php/";
const AdminListing = (props) => {
  const [error, setError] = useState(false);
  const [errorValue, setErrorValue] = useState("");
  const [listings, setListings] = useState([]);
  // const [approved, setApproved] = useState([]);
  // const [pending, setPending] = useState([]);
  const [success, setSuccess] = useState(false);
  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(true);
  const [spin, setSpin] = useState(false);
  const [spinReason, setSpinReason] = useState(false);
  const [declineDetails, setDeclineDetails] = useState("");
  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(15);

  async function handleApprove(details) {
    let sure = window.confirm("Are you sure you want to approve?");
    if (details && sure) {
      setSpin(true);
      // const formData = new FormData();
      // formData.append("owner", details.owner);
      // formData.append("refID", details.refID);
      await axios
        .post(urlUpdate, {
          owner: details.owner,
          email: details.linkedin,
          refID: details.refID,
        })
        .then(({ data }) => {
          if (data.success === 1) {
            setSuccess(true);
            setErrorValue(data.msg);
            setError(false);
            setSpin(false);
            props.history.push("/admin/listings");
          } else if (data.success === 0) {
            setErrorValue(data.msg);
            setError(true);
            setSuccess(false);
            setSpin(false);
          }
        });
    }
  }
  // async function onOpen(owner) {
  //   await axios.post(urlOwner, { owner: owner }).then((res) => {
  //     window.open(
  //       `https://www.hubsquares.com/php_files/documents/${res.data.user.document}`,
  //       "_blank"
  //     );
  //   });
  // }
  async function handleRemove(details) {
    let sure = window.confirm("Are you sure you want to remove?");
    if (details && sure) {
      setSpin(true);
      const formData = new FormData();
      formData.append("owner", details.owner);
      formData.append("refID", details.refID);
      formData.append("owner", details.owner);
      await axios.post(urlRemove, formData).then(({ data }) => {
        if (data.success === 1) {
          setSuccess(true);
          setErrorValue(data.msg);
          setError(false);
          setSpin(false);
          props.history.push("/admin/listings");
        } else if (data.success === 0) {
          setErrorValue(data.msg);
          setError(true);
          setSuccess(false);
          setSpin(false);
        }
      });
    }
  }
  async function onReasonDecline() {
    const form = new FormData();
    form.append("owner", declineDetails.owner);
    form.append("refID", declineDetails.refID);
    form.append("email", declineDetails.linkedin);
    form.append("reason", reason);

    if (declineDetails && reason) {
      setSpinReason(true);
      await axios.post(urlDecline, form).then(({ data }) => {
        if (data.success === 1) {
          alert(data.msg);
          setSpinReason(false);
          props.history.push("/admin/listings");
        } else if (data.success === 0) {
          setSpinReason(false);
          alert(data.msg);
        }
      });
    }
  }
  function onView(refID) {
    if (props.user === "Admin") {
      props.history.push(`/admin/listing-details/${refID}`);
    } else {
      props.history.push(`/listing-details/${refID}`);
    }
  }
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = listings
    .filter((list) => list.status !== "approved")
    .slice(indexOfFirstPost, indexOfLastPost);
  const paginate = (pageNum) => {
    setCurrentPage(pageNum);
    window.scrollTo(0, 420);
  };

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    window.scrollTo(0, 420);
  };

  const prevPage = () => {
    setCurrentPage(currentPage - 1);
    window.scrollTo(0, 420);
  };
  useEffect(() => {
    const fetchListing = () => {
      axios.get(url).then((res) => {
        if (res.data.listing) setListings(res.data.listing);
      });
    };
    fetchListing();
    setLoading(false);
  }, []);
  useEffect(() => {
    if (error || success) {
      setTimeout(() => {
        setError(false);
        setSuccess(false);
        setErrorValue("");
      }, 5000);
    }
  }, [error, success]);
  
  return (
    <>
      <CustomHelmet page="Admin Dashboard" />
      <Dashboard page="All Listings">
        <Tabs
          defaultActiveKey="new"
          className="bg-dark px-3"
          id="uncontrolled-tab-example"
        >
          <Tab eventKey="new" className="mx-3 mt-3" title="New">
            <div className="my-3">
              {error && (
                <Fade bottom collapse when={error}>
                  <Alert variant="danger">{errorValue}</Alert>
                </Fade>
              )}
              {success && (
                <Fade bottom collapse when={success}>
                  <Alert variant="success">{errorValue}</Alert>
                </Fade>
              )}
              {spin && (
                <Spinner animation="border" role="status">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              )}
            </div>

            {!loading ? (
              currentPosts.map((list) => (
                <div className="mb-2" key={list.refID}>
                  <AdminListingContainer
                    status={list.status}
                    location={`${list.state}, ${list.country}`}
                    title={list.title}
                    pending={true}
                    onApprove={() => handleApprove(list)}
                    onDecline={() => {
                      setDeclineDetails(list);
                      setShow(true);
                    }}
                    onView={() => onView(list.refID)}
                  />
                </div>
              ))
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
            <Pagination
              postsPerPage={postsPerPage}
              totalPosts={listings.length}
              paginate={paginate}
              nextPage={nextPage}
              prevPage={prevPage}
              current={currentPage}
            />
          </Tab>
          <Tab eventKey="approved" className="mx-3 mt-3" title="Approved">
            <div className="mt-4 row">
              <div className="col-md-3"></div>
              <div className="form-group col-md-6">
                <input
                  type="text"
                  className="form-control form-control-lg input_2"
                  placeholder="Search business title or owner"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
              <div className="col-md-3"></div>
            </div>
            {!loading ? (
              listings
                .filter(
                  (list) =>
                    list.status === "approved" &&
                    (keyword === "" ||
                      list.title
                        .toLowerCase()
                        .includes(keyword.toLowerCase()) ||
                      list.owner.toLowerCase().includes(keyword.toLowerCase()))
                )
                .map((list) => (
                  <div className="mb-2" key={list.refID}>
                    <AdminListingContainer
                      approve={true}
                      analytics={list.counter}
                      status={list.status}
                      onremove={()=>handleRemove(list)}
                      location={`${list.state}, ${list.country}`}
                      title={list.title}
                      onApprove={() => handleApprove(list)}
                      onView={() => onView(list.refID)}
                    />
                  </div>
                ))
            ) : (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            )}
          </Tab>
        </Tabs>
        <Modal
          show={show}
          onHide={() => setShow(false)}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Reason</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder=""
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={onReasonDecline}>
              Decline
              {spinReason && (
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Dashboard>
    </>
  );
};
export default AdminListing;
